import { WEBSOCKETS_UPDATED, NETWORK_STATUS_UPDATED, RECONNECTING_UPDATED } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';

var NetworkConnectionStatusService = /** @class */ (function () {
    function NetworkConnectionStatusService() {
        this.isWebsocketConnected = true;
        this.isNetworkConnected = true;
        this.registerSchemas();
        this.registerEvents();
        this.initializeValues();
        this.initConnectionListeners();
    }
    NetworkConnectionStatusService.prototype.initializeValues = function () {
        window.eventBus.publish(WEBSOCKETS_UPDATED, true);
        window.eventBus.publish(NETWORK_STATUS_UPDATED, true);
    };
    NetworkConnectionStatusService.prototype.registerEvents = function () {
        var _this = this;
        window.eventBus.subscribe(WEBSOCKETS_UPDATED, function (e) {
            _this.isWebsocketConnected = e.payload;
            _this.publishReconnectingUpdate(_this.isWebsocketConnected);
        });
        window.eventBus.subscribe(NETWORK_STATUS_UPDATED, function (e) {
            _this.isNetworkConnected = e.payload;
            _this.publishReconnectingUpdate(_this.isNetworkConnected);
        });
    };
    NetworkConnectionStatusService.prototype.publishReconnectingUpdate = function (status) {
        window.eventBus.publish(RECONNECTING_UPDATED, !status);
    };
    NetworkConnectionStatusService.prototype.registerSchemas = function () {
        window.eventBus.register(WEBSOCKETS_UPDATED, {
            type: 'boolean',
        });
        window.eventBus.register(NETWORK_STATUS_UPDATED, {
            type: 'boolean',
        });
        window.eventBus.register(RECONNECTING_UPDATED, {
            type: 'boolean',
        });
    };
    NetworkConnectionStatusService.prototype.initConnectionListeners = function () {
        var DELAY_MS = 5000;
        var websocketDelay;
        var networkDelay;
        // Websocket Events
        magic.events.wsDisconnected(function () {
            clearTimeout(websocketDelay);
            websocketDelay = setTimeout(function () {
                window.eventBus.publish(WEBSOCKETS_UPDATED, false);
            }, DELAY_MS);
        });
        magic.events.wsConnected(function () {
            var user = magic.session.getUser();
            if (user) {
                magic.methods.users.subscribeForTags(user);
            }
            clearTimeout(websocketDelay);
            window.eventBus.publish(WEBSOCKETS_UPDATED, true);
        });
        // Network Events
        window.addEventListener('offline', function () {
            clearTimeout(networkDelay);
            networkDelay = setTimeout(function () {
                window.eventBus.publish(NETWORK_STATUS_UPDATED, false);
            }, DELAY_MS);
        });
        window.addEventListener('online', function () {
            var user = magic.session.getUser();
            if (user) {
                magic.methods.users.subscribeForTags(user);
            }
            clearTimeout(networkDelay);
            window.eventBus.publish(NETWORK_STATUS_UPDATED, true);
        });
    };
    return NetworkConnectionStatusService;
}());

export { NetworkConnectionStatusService };
